var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.585 10.411-3.772 3.772m5.984-9.755L6.755 5.47c-.085.085-.127.127-.176.161a.667.667 0 0 1-.138.074 1.401 1.401 0 0 1-.231.057l-2.443.488c-.635.127-.952.19-1.1.358a.667.667 0 0 0-.163.534c.031.222.26.45.718.909l4.724 4.723c.457.458.686.687.908.718a.666.666 0 0 0 .534-.162c.167-.148.23-.466.358-1.1l.488-2.444c.024-.117.036-.176.057-.231a.668.668 0 0 1 .074-.138c.034-.048.076-.09.161-.176l1.04-1.04c.055-.055.082-.082.112-.105a.666.666 0 0 1 .084-.057c.033-.02.068-.034.139-.064l1.663-.713c.485-.208.727-.312.838-.48a.666.666 0 0 0 .095-.498c-.04-.197-.226-.384-.6-.757L10.47 2.097c-.373-.373-.56-.56-.757-.6a.667.667 0 0 0-.498.097c-.168.11-.272.352-.48.837l-.712 1.663c-.03.07-.046.106-.065.14a.666.666 0 0 1-.056.083c-.024.03-.051.057-.106.111Z",
    stroke: "#4A49BB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPin;